import defaultTemplate from './tsz-toast.html';
import './tsz-toast.styl';

/**
 * Wrapper of $mdToast
 * @param message - the toast text
 * @param object - the rest of toast options
 */
function tszToastService($mdToast, $translate) {

  'ngInject';

  const getHideDelay = (str) => {
    const avgWordsPerMinute = 250; // words average read per minute
    const defaultDelay = 3000; // ms
    const wordsCount = str.split(' ').length;

    const averageTime = (wordsCount * 60000) / avgWordsPerMinute;
    return (averageTime > defaultDelay) ? averageTime : defaultDelay;
  };

  function defaultController() {
    this.onButtonClick = () => $mdToast.hide();
  }

  function show(textContent, options = {}) {

    const defaults = {
      textContent,
      hideDelay: getHideDelay(textContent),
      template: defaultTemplate,
      controller: defaultController,
      position: 'top right',
    };
    const toastPreset = { ...defaults, ...options };

    return $mdToast.show($mdToast.simple(toastPreset));
  }

  return {

    show,

    // Shows a black toast with a generic message
    showInfo(message, params) {
      return show(message, params);
    },

    // Shows a green toast with a success message
    showSuccess(message, params) {
      return show(message, { success: true, ...params });
    },

    // Shows a red toast with an error message
    showError(message, params) {
      return show(message, { error: true, ...params });
    },

    showErrorI18n(message, defaultMsg, params) {
      $translate(`ERROR.${message}`)
      .then(
        (errorMsg) => show(errorMsg, { error: true, ...params }),
        () => show(defaultMsg, { error: true, ...params }));
    },

    // Shows a yellow toast with a warning message
    showWarning(message, params) {
      return show(message, { warning: true, ...params });
    },

    // Hides the toast
    hide() {
      return $mdToast.hide();
    },
  };
}

export default tszToastService;



// WEBPACK FOOTER //
// ./src/components/tsz-toast/tsz-toast.service.js